import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import section2img from "../assests/HomeImg/section2-img.svg";

const HomeIcon = () => (
    <svg className="int-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const DownArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4 6L8 10L12 6" stroke="#99A1AF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const LabIcon = ({ color }) => (
    <div className="int-lab-icon-bg" style={{ background: `${color}18` }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 2v8L4.5 20.29c-.4.44-.5 1.05-.3 1.58.2.53.7.88 1.3.88h13c.6 0 1.1-.35 1.3-.88.2-.53.1-1.14-.3-1.58L14 10V2" />
            <path d="M8 2h8" />
            <path d="M7 16h10" />
        </svg>
    </div>
);

// Custom hook for counter animation
function useCounter(target, duration = 1500) {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const tick = (now) => {
                        const elapsed = now - start;
                        const progress = Math.min(elapsed / duration, 1);
                        setCount(Math.floor(progress * target));
                        if (progress < 1) requestAnimationFrame(tick);
                        else setCount(target);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.3 }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [target, duration]);

    return { count, ref };
}

// Animated counter component
function AnimatedCounter({ value, className }) {
    const numeric = typeof value === 'number' ? value : parseInt(value, 10) || 0;
    const { count, ref } = useCounter(numeric, 1500);

    return (
        <span ref={ref} className={className}>
            {count}
        </span>
    );
}



const intermediatesData = [
    {
        id: 1,
        name: "Abacavir",
        count: 5,
        color: "#0D9488",
        items: [
            { no: "01", name: "(1S,4R)-(4-Aminocyclopent-2-enyl) methanol hydrochloride", cas: "168960-19-8" },
            { no: "02", name: "(1S-cis)-4-Amino-2-cyclopentene-1-methanol D-hydrogen tatrate", cas: "229177-52-0" },
            { no: "03", name: "N-(2-Amino-4,6-dichloropyrimidin-5-yl)formamide", cas: "171887-03-9" },
            { no: "04", name: "N-[2-Amino-4-chloro-6-[[(1R,4S)-4-(hydroxymethyl)-2-cyclopenten-1-yl]amino]-5-pyrimidinyl]formamide", cas: "171887-04-0" },
            { no: "05", name: "(1S,4R)-4-(2-Amino-6-chloro-9H-purin-9-yl)-2-cyclopentene-1-methanol Hydrochloride", cas: "172015-79-1" }
        ]
    },
    {
        id: 2,
        name: "Atomoxetine",
        count: 3,
        color: "#7C3AED",
        items: [
            { no: "01", name: "3-(Dimethylamino)-1-phenylpropan-1-one hydrochloride", cas: "3506-36-3" },
            { no: "02", name: "3-(Dimethylamino)-1-phenylpropan-1-ol", cas: "36296-95-4" },
            { no: "03", name: "3-(4-(Trifluoromethyl)phenoxy)-N,N-dimethyl-3-phenylpropan-1-amine", cas: "56225-81-1" }
        ]
    },
    {
        id: 3,
        name: "Alprazolam",
        count: 1,
        color: "#6D28D9",
        items: [
            { no: "01", name: "7-chloro-1, 3-dihydro-5-phenyl-2H-1, 4-benzodiazepin-2-thione", cas: "4547-02-8" }
        ]
    },
    {
        id: 4,
        name: "Apixaban",
        count: 3,
        color: "#DC2626",
        items: [
            { no: "01", name: "(Z)-Ethyl 2-chloro-2-(2-(4-methoxyphenyl) hydrazono)acetate", cas: "27143-07-3" },
            { no: "02", name: "5,6-Dihydro-3-(4-morpholinyl)-1-[4-(2-oxo-1-piperidinyl)phenyl]-2(1H)-pyridinone", cas: "545445-44-1" },
            { no: "03", name: "Ethyl 4,5,6,7-tetrahydro-1-(4-methoxyphenyl)-7-oxo-6-(4-(2-oxopiperidin-1-yl)phenyl)-1H-pyrazolo [3,4-c] pyridine-3-carboxylate", cas: "503614-91-3" }
        ]
    },
    {
        id: 5,
        name: "Bedaquiline",
        count: 3,
        color: "#059669",
        items: [
            { no: "01", name: "3-Benzyl-6-bromo-2-methoxyquinoline", cas: "654655-69-3" },
            { no: "02", name: "3-Dimethylamino-1-(naphthalen-1-yl)propan-1-one hydrochloride", cas: "5409-58-5" },
            { no: "03", name: "Racemic Bedaquiline", cas: "" }
        ]
    },
    {
        id: 6,
        name: "Baclofen",
        count: 3,
        color: "#B45309",
        items: [
            { no: "01", name: "2,4-Diacetyl-3-(4-chloro-phenyl)-pentanedioic acid diethyl ester", cas: "84803-73-6" },
            { no: "02", name: "3-(4-Chloro-phenyl)-pentanedioic acid", cas: "35271-74-0" },
            { no: "03", name: "4-Carbamoyl-3-(4-chloro-phenyl)-butyric acid", cas: "1141-23-7" }
        ]
    },
    {
        id: 7,
        name: "Canagliflozin",
        count: 1,
        color: "#0284C7",
        items: [
            { no: "01", name: "2,3,4,6-Tetrakis-O-trimethylsilyl-D-gluconolactone", cas: "32384-65-9" }
        ]
    },
    {
        id: 8,
        name: "Cinacalcet",
        count: 1,
        color: "#9333EA",
        items: [
            { no: "01", name: "3-(Trifluoromethyl)cinnamic acid", cas: "779-89-5" }
        ]
    },
    {
        id: 9,
        name: "Clomiphene Citrate",
        count: 1,
        color: "#E11D48",
        items: [
            { no: "01", name: "1-(4-(2-(diethylamino)ethoxy)phenyl)-1,2-diphenylethanol", cas: "73404-00-9" }
        ]
    },
    {
        id: 10,
        name: "Dabigatran",
        count: 2,
        color: "#0D9488",
        items: [
            { no: "01", name: "3-[(3-Amino-4-methylaminobenzoyl)pyridin-2-ylamino]propionic acid ethyl ester", cas: "212322-56-0" },
            { no: "02", name: "3-[[[2-[[(4-Cyanophenyl)amino]methyl]-1-methyl-1H-benzimidazol-5-yl]carbonyl] pyridin-2-ylamino]propionicacid ethyl ester", cas: "211915-84-3" }
        ]
    },
    {
        id: 11,
        name: "Dapagliflozin",
        count: 3,
        color: "#7C3AED",
        items: [
            { no: "01", name: "4-(5-bromo-2-chlorobenzyl)phenyl ethyl ether", cas: "461432-23-5" },
            { no: "02", name: "5-Bromo-2-chlorobenzoic acid", cas: "21739-92-4" },
            { no: "03", name: "(5-Bromo-2-chlorophenyl)(4-ethoxy-phenyl) methanone", cas: "461432-22-4" }
        ]
    },
    {
        id: 12,
        name: "Dabrafenib",
        count: 3,
        color: "#DC2626",
        items: [
            { no: "01", name: "Methyl 3-{[2,6-difluorophenyl) sulfonyl]amino}-2-fluoro-benzoate", cas: "1195768-19-4" },
            { no: "02", name: "N-{3-[(2-Chloro-4-pyrimidinyl)acetyl]-2-fluorophenyl}-2,6-difluorobenzene sulfonamide", cas: "1195768-20-7" },
            { no: "03", name: "N-{3-[5-(2-Chloro-4-pyrimidinyl)-2-(1,1-dimethylethyl)-1,3-thiazol-4-yl]-2-fluorophenyl}-2,6-difluorobenzene Sulfonamide", cas: "1195768-23-0" }
        ]
    },
    {
        id: 13,
        name: "Doxazosin",
        count: 2,
        color: "#059669",
        items: [
            { no: "01", name: "2-chloro-4-amino-6,7-dimethoxy Quinazoline", cas: "23680-84-4" },
            { no: "02", name: "1-(1,4-Benzodioxan-2-ylcarbonyl) piperazine hydrochloride", cas: "70918-00-2" }
        ]
    },
    {
        id: 14,
        name: "Delamanid",
        count: 2,
        color: "#B45309",
        items: [
            { no: "01", name: "4-[4-(Trifluoromethoxy)phenoxy] piperidine", cas: "287952-67-4" },
            { no: "02", name: "4-(4-(4-Trifluoromethoxy) phenoxy) piperidin-1-yl)phenol 4-methyl benzenesulfonic acid", cas: "866109-93-5" }
        ]
    },
    {
        id: 15,
        name: "Edoxaban",
        count: 4,
        color: "#0284C7",
        items: [
            { no: "01", name: "2-Amono-5-chloro pyridine(CAP)", cas: "1072-98-6" },
            { no: "02", name: "4,5,6,7-tetrahydro-5-methylthiazolo[5,4-c]pyridine-2-carboxylic acid hydrochloride (EDX-III)", cas: "720720-96-7" },
            { no: "03", name: "N-(5-Chloro-pyridin-2-yl)-oxalamic acid methyl ester hydrochloride", cas: "480450-68-8" },
            { no: "04", name: "tert-Butyl((1R,2S,5S)-2-(2-((5-chloropyridin-2-yl)amino)-2-oxoacetamido)-5-(dimethylcarbamoyl)cyclohexyl) carbamate", cas: "480452-36-6" }
        ]
    },
    {
        id: 16,
        name: "Empagliflozin",
        count: 4,
        color: "#9333EA",
        items: [
            { no: "01", name: "(3S)-3-[4-[(5-Bromo-2-chlorophenyl)methyl] phenoxy]tetrahydro-furan", cas: "915095-89-5" },
            { no: "02", name: "(S)-(+)-3-Hydroxytetrahydrofuran", cas: "86087-23-2" },
            { no: "03", name: "R-(+)-3-hydroxytetrahydrafuran", cas: "86087-24-3" },
            { no: "04", name: "3,4,5-Tris-trimethylsilanyloxy-6-trimethylsilanyloxymethyl-tetrahydro-pyran-2-one", cas: "32384-65-9" }
        ]
    },
    {
        id: 17,
        name: "Ezetimibe",
        count: 7,
        color: "#E11D48",
        items: [
            { no: "01", name: "5-(4-Fluorophenyl)-5-oxopentanoic acid", cas: "149437-76-3" },
            { no: "02", name: "(4S)-3-[5-(4-Fluorophenyl)-1,5-dioxopenyl]-4-phenyl-2-oxazolidinone", cas: "189028-93-1" },
            { no: "03", name: "(S)-(+)-4-Phenyl-2-oxazolidinone", cas: "99395-88-7" },
            { no: "04", name: "4-{(E)-[(4-Fluorophenyl)imino]methyl}phenol", cas: "3382-63-6" },
            { no: "05", name: "(R)-(+)-4-phenyl-2-oxazolidinone", cas: "90319-52-1" },
            { no: "06", name: "(S)-4-Phenyl-3-[5-(4-fluorophenyl)-5-oxopentanoyl]-2-oxazolidinone", cas: "189028-93-1" },
            { no: "07", name: "(S)-3-((2R,5S)-5-(4-Fluorophenyl)-2-((S)-((4-fluoro phenyl) amino)(4-((trimethylsilyl)oxy)-phenyl) methyl)-5-((trimethylsilyl)oxy) pentanoyl)-4-phenyl oxazolidin-2-one", cas: "272778-12-8" }
        ]
    },
    {
        id: 18,
        name: "Finerenone",
        count: 4,
        color: "#0D9488",
        items: [
            { no: "01", name: "Benzyl 2-(4-cyano-2-methoxybenzylidene)-3-oxobutanoate", cas: "2869115-38-6" },
            { no: "02", name: "Benzyl 4-(4-cyano-2-methoxyphenyl)-1,4,5,6-tetrahydro-2,8-dimethyl-5-oxo-1,6-naphthyridine-3-carboxylate", cas: "2389020-00-0" },
            { no: "03", name: "Benzyl 4-(4-cyano-2-methoxyphenyl)-5-ethoxy-1,4-dihydro-2,8-dimethyl-1,6-naphthyridine-3-carboxylate", cas: "2820463-47-4" },
            { no: "04", name: "(S)-Benzyl 4-(4-cyano-2-methoxyphenyl)-5-ethoxy-1,4-dihydro-2,8-dimethyl-1,6-naphthyridine-3-carboxylate", cas: "2869115-40-0" }
        ]
    },
    {
        id: 19,
        name: "Glycopyrrolate",
        count: 2,
        color: "#7C3AED",
        items: [
            { no: "01", name: "Methyl-2-cyclopentyl-2-hydroxy-2-phenylacetate", cas: "19833-96-6" },
            { no: "02", name: "1-Methylpyrrolidin-3-yl 2-cyclopentyl-2-hydroxy-2-phenylacetate", cas: "13118-11-1" }
        ]
    },
    {
        id: 20,
        name: "Hydroxyzine Hydrochloride",
        count: 1,
        color: "#DC2626",
        items: [
            { no: "01", name: "4 Chloro benzhydryl piperazin (BJP)", cas: "303-26-4" }
        ]
    },
    {
        id: 21,
        name: "Ivacaftor",
        count: 4,
        color: "#059669",
        items: [
            { no: "01", name: "4-Oxo-1,4-dihydroquinoline-3-carboxylic acid", cas: "13721-01-2" },
            { no: "02", name: "5-Amino-2,4-di-tert-butylphenol", cas: "873055-58-4" },
            { no: "03", name: "2,4-di-tert-butyl-5-nitrophenyl methyl carbonate", cas: "873055-55-1" },
            { no: "04", name: "Ethyl 4-oxo-1,4-dihydroquinoline-3-carboxylate", cas: "52980-28-6" }
        ]
    },
    {
        id: 22,
        name: "Ketoconazole",
        count: 2,
        color: "#B45309",
        items: [
            { no: "01", name: "Cis-Bromo benzoate", cas: "61397-56-6" },
            { no: "02", name: "Cis-[2-(2,4-dichlorphenyl)-2-(1H-imidazol-1-methyl)-dioxolanbenzenesulfonate", cas: "134071-44-6" }
        ]
    },
    {
        id: 23,
        name: "Losartan, Irbesartan",
        count: 3,
        color: "#0284C7",
        items: [
            { no: "01", name: "4'-Bromomethyl-2-biphenylcarbonitrile", cas: "114772-54-2" },
            { no: "02", name: "5-(4'-Bromomethyl-1,1'-biphenyl-2-yl)-1-triphenylmethyl-1H-tetrazole", cas: "124750-51-2" },
            { no: "03", name: "2-n-Butyl-4-Chloro-1-[(2'-cyanobiphenyl-4-yl)methyl]-5-hydroxymethylimidazole", cas: "114772-55-3" }
        ]
    },
    {
        id: 24,
        name: "Lacosamide",
        count: 1,
        color: "#9333EA",
        items: [
            { no: "01", name: "tert-butyl (R)-1 (benzylcarbamoyl) -2-hydroxyethyl carbamate", cas: "1253790-58-7" }
        ]
    },
    {
        id: 25,
        name: "Linagliptin",
        count: 3,
        color: "#E11D48",
        items: [
            { no: "01", name: "8-Bromo-7-but-2-ynyl-3-methyl-3,7-dihydro-purine-2,6-dione", cas: "666816-98-4" },
            { no: "02", name: "8-Bromo-7-but-2-ynyl-3-methyl-1-(4-methyl-quinazolin-2-ylmethyl)-3,7-dihydro-purine-2,6-dione", cas: "853029-57-9" },
            { no: "03", name: "(R)-tert-Butyl(1-(7-(but-2-yn-1-yl)-3-methyl-1-((4-methyl quinazolin-2-yl)methyl)-2,6-dioxo-2,3,6,7-tetrahydro-1H-purin-8-yl)piperidin-3-yl)carbamate", cas: "668273-75-4" }
        ]
    },
    {
        id: 26,
        name: "Letemovir",
        count: 1,
        color: "#0D9488",
        items: [
            { no: "01", name: "1-(2-Bromo-6-fluorophenyl)-3-(2-methoxy-5-(trifluoromethyl)phenyl)urea", cas: "917389-23-2" }
        ]
    },
    {
        id: 27,
        name: "Levodropropizine",
        count: 1,
        color: "#7C3AED",
        items: [
            { no: "01", name: "1-Phenylpiperazine", cas: "92-54-6" }
        ]
    },
    {
        id: 28,
        name: "Macitentan",
        count: 2,
        color: "#DC2626",
        items: [
            { no: "01", name: "4,6-Dichloro-5-(4-bromophenyl)-pyrimidine", cas: "146533-41-7" },
            { no: "02", name: "5-bromo-2-chloro pyrimidine", cas: "32779-36-5" }
        ]
    },
    {
        id: 29,
        name: "Milnacipran",
        count: 2,
        color: "#059669",
        items: [
            { no: "01", name: "(1S,5R)-1-Phenyl-3-oxabicyclo[3.1.0] hexan-2-one", cas: "63106-93-4" },
            { no: "02", name: "(1S,5R)-1-Phenyl-3-oxabicyclo[3.1.0] hexan-2-one (levomilnacipran)", cas: "96847-53-9" }
        ]
    },
    {
        id: 30,
        name: "Olmesartan Medoxomil",
        count: 2,
        color: "#B45309",
        items: [
            { no: "01", name: "4-(1-Hydroxy-1-methylethyl)-2-propyl-1-[[2'-[2-(triphenylmethyl)-2H-tetrazol-5-yl][1,1'-biphenyl]-4-yl]methyl]-1H-imidazole-5-carboxylic Acid Ethyl Ester", cas: "172875-59-1" },
            { no: "02", name: "(5-Methyl-2-oxo-1,3-dioxol-4-yl)methyl 4-(2-hydroxypropan-2-yl)-2-propyl-1-((2'-(1-trityl-1H-tetrazol-5-yl)-[1,1'-biphenyl]-4-yl)methyl)-1H-imidazole-5-carboxylate", cas: "144690-92-6" }
        ]
    },
    {
        id: 31,
        name: "Olaparib",
        count: 1,
        color: "#0284C7",
        items: [
            { no: "01", name: "4-(4-Fluoro-3-(piperazine-1-carbonyl)benzyl)phthalazin-1(2H)-one", cas: "763111-47-3" }
        ]
    },
    {
        id: 32,
        name: "Prasugrel",
        count: 4,
        color: "#9333EA",
        items: [
            { no: "01", name: "1-Cyclopropyl-2-fluorobenzyl ketone", cas: "150322-73-9" },
            { no: "02", name: "2-Bromo-2-(2-fluorophenyl)-1-cyclopropylethanone", cas: "204205-33-4" },
            { no: "03", name: "5,6,7,7a-Tetrahydro-5-tritylthieno", cas: "109904-26-9" },
            { no: "04", name: "5,6,7,7a-Tetrahydrothieno[3,2-c]pyridine-2(4H)-one hydrochloride", cas: "115473-15-9" }
        ]
    },
    {
        id: 33,
        name: "Pregabalin",
        count: 5,
        color: "#E11D48",
        items: [
            { no: "01", name: "Isobutyl Glutaric acid", cas: "75143-89-4" },
            { no: "02", name: "R-(-)-3-(carbamoyl methyl)-5-methyl hexanoic acid", cas: "181289-33-8" },
            { no: "03", name: "(±)-3-(carbamoyl methyl)-5-methyl hexanoic acid", cas: "181289-15-6" },
            { no: "04", name: "(S)-Ethyl 3-cyano-5-methyl-hexanoate", cas: "181289-39-4" },
            { no: "05", name: "3-Cyano-2-ethoxycarbonyl-5-methyl-hexanoic acid ethyl ester (CNDE)", cas: "186038-82-4" }
        ]
    },
    {
        id: 34,
        name: "Rivastigmine",
        count: 1,
        color: "#0D9488",
        items: [
            { no: "01", name: "(S)-3-[1-(Dimethylamino)ethyl]phenol", cas: "139306-10-8" }
        ]
    },
    {
        id: 35,
        name: "Rivoraxaban",
        count: 6,
        color: "#7C3AED",
        items: [
            { no: "01", name: "4-(4-Aminophenyl)-morpholin-3-one", cas: "438056-69-0" },
            { no: "02", name: "(S)-(+)-N-(2,3-Epoxypropyl)phthalimide", cas: "161596-47-0" },
            { no: "03", name: "4-(4-(5-(Aminomethyl)-2-oxoxazolidin-3-yl)phenyl)morpholin-3-one hydrochloride", cas: "898543-06-1" },
            { no: "04", name: "(R)-4-[4-(3-Phthalimido-2-hydroxy propylamino) phenyl]-morpholin-3-one", cas: "446292-07-5" },
            { no: "05", name: "(S)-2-[[2-Oxo-3-[4-(3-oxo-morpholino)phenyl] oxazolidin-5-yl]methyl]isoindoline-1,3-dione", cas: "446292-08-6" },
            { no: "06", name: "5-Chlorothiophene-2-carboxylic acid", cas: "24065-33-6" }
        ]
    },
    {
        id: 36,
        name: "Selexipag",
        count: 2,
        color: "#DC2626",
        items: [
            { no: "01", name: "4-(Isopropylamino)butanol", cas: "42042-71-7" },
            { no: "02", name: "5-chloro-2,3-diphenylpyrazine", cas: "41270-66-0" }
        ]
    },
    {
        id: 37,
        name: "Sertraline",
        count: 4,
        color: "#059669",
        items: [
            { no: "01", name: "4-(3,4-Dichlorophenyl)-3,4-dihydro-1-(2H)-napthalone", cas: "79560-19-3" },
            { no: "02", name: "4-(3,4-Dichlorophenyl)-1,2,3,4-tetrahydro-N-methyl-1-naphthalenimine", cas: "79560-20-6" },
            { no: "03", name: "Cis-N-methyl-4-(3,4-dichlorophenyl)-1,2,3,4-tetrahydro-1-naphthaleneamine HCl", cas: "79617-89-3" },
            { no: "04", name: "Schiff base ([4-(3,4-Dichloro-phenyl)-3,4-dihydro-2H-naphthalen-1-ylidene]-methyl-amine)", cas: "152642-35-8" }
        ]
    },
    {
        id: 38,
        name: "Ticagrelor",
        count: 2,
        color: "#B45309",
        items: [
            { no: "01", name: "4,6-dichloro-2-propylthiopyrimidine-5-amine", cas: "145783-15-9" },
            { no: "02", name: "2-((3aR,4S,6R,6aS)-6-((5-amino-6-chloro-2-(propylthio)pyrimidin-4-yl)amino)-2,2'-dimethyl tetrahydro-4H-cyclopenta[d][1,3]dioxol-4-yl) oxy)ethan-1-ol", cas: "376608-74-1" }
        ]
    },
    {
        id: 39,
        name: "Venetoclax",
        count: 5,
        color: "#0284C7",
        items: [
            { no: "01", name: "5-bromo-1H-pyrrolo[2,3-b]pyridine", cas: "183208-35-7" },
            { no: "02", name: "1-(triisopropylsilyl)-1H-pyrrolo[2,3-b]pyridin-5-ol", cas: "685514-01-6" },
            { no: "03", name: "3-Nitro-4-(((tetrahydro-2H-pyran-4-yl)methyl)amino)benzenesulfonamide", cas: "1228779-96-1" },
            { no: "04", name: "Methyl 2-((1H-pyrrolo[2,3-b]pyridin-5-yl)oxy)-4-fluorobenzoate", cas: "1235865-77-6" },
            { no: "05", name: "1-((4'-chloro-5,5-dimethyl-3,4,5,6-tetrahydro-[1,1'-biphenyl]-2-yl)methyl)piperazine", cas: "1628047-87-9" }
        ]
    },
    {
        id: 40,
        name: "Verapamil/Etripamil",
        count: 2,
        color: "#9333EA",
        items: [
            { no: "01", name: "(3,4-Dimethoxyphenyl)acetonitrile", cas: "93-17-4" },
            { no: "02", name: "2-(3,4-Dimethoxyphenyl)-3-methylbutanenitrile", cas: "20850-49-1" }
        ]
    },
    {
        id: 41,
        name: "Valbenazine Tosylate",
        count: 1,
        color: "#E11D48",
        items: [
            { no: "01", name: "(2R,3R,11bR)-3-ISOBUTYL-9,10-DIMETHOXY-1,3,4,6,7,11b-hexahydro-2H-pyrido[2,1-a]isoquinolin-2-ol ((1S)-7,7-dimethyl-2-oxobicyclo[2.2.1]heptan-1-yl)methanesulfonate", cas: "2102090-15-1" }
        ]
    },
    {
        id: 42,
        name: "Vonoprazan Fumarate",
        count: 1,
        color: "#0D9488",
        items: [
            { no: "01", name: "5-(2-Fluoro-phenyl)-1-(pyridine-3-sulfonyl)-1H-pyrrole-3-carbaldehyde", cas: "881677-11-8" }
        ]
    },
    {
        id: 43,
        name: "Viloxazine Hydrochloride",
        count: 1,
        color: "#7C3AED",
        items: [
            { no: "01", name: "2-((2-Ethoxyphenoxy) methyl) oxirane", cas: "5296-35-5" }
        ]
    },
    {
        id: 44,
        name: "Vilazodone Hydrochloride",
        count: 3,
        color: "#DC2626",
        items: [
            { no: "01", name: "Methyl 5-(piperazin-1-yl)benzofuran-2-carboxylate", cas: "1186225-86-4" },
            { no: "02", name: "Toluene-4-sulfonic acid 4-(5-cyano-1H-indol-3-yl)-butyl ester", cas: "1351235-11-4" },
            { no: "03", name: "5-{4-[4-(5-Cyano-1H-indol-3-yl)-butyl]-piperazin-1-yl}-benzofuran-2-carboxylic acid methyl ester hydrogen sulfate", cas: "2410057-47-3" }
        ]
    },
    {
        id: 45,
        name: "Vildagliptin",
        count: 2,
        color: "#059669",
        items: [
            { no: "01", name: "3-Amino-1-adamantanol", cas: "702-82-9" },
            { no: "02", name: "(S)-1-(2-Chloroacetyl)pyrrolidin-2-carbonitrile", cas: "207557-35-3" }
        ]
    }
];

const Intermediates = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    // ========================
    //  SCROLL REVEAL ANIMATIONS
    // ========================
    useEffect(() => {
        // Pre-mark all stagger children as hidden
        document.querySelectorAll("[data-stagger]").forEach((grid) => {
            Array.from(grid.children).forEach((child) => {
                child.classList.add("anim-child");
            });
        });

        // Observer for stagger grids — each child animates individually
        const staggerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        Array.from(entry.target.children).forEach((child, i) => {
                            child.style.animationDelay = `${i * 0.13}s`;
                            child.classList.add(
                                i % 2 === 0 ? "anim-from-left" : "anim-from-right"
                            );
                        });
                        staggerObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );

        document
            .querySelectorAll("[data-stagger]")
            .forEach((el) => staggerObserver.observe(el));

        // Observer for section-level reveals
        const sectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        sectionObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.06 }
        );

        document
            .querySelectorAll(".scroll-reveal, .sr-left, .sr-right")
            .forEach((el) => sectionObserver.observe(el));

        return () => {
            staggerObserver.disconnect();
            sectionObserver.disconnect();
        };
    }, []);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    // Helper to get translucent color for gradient
    const getTranslucentColor = (hex, opacity) => {
        const h = hex.replace('#', '');
        const r = parseInt(h.substring(0, 2), 16);
        const g = parseInt(h.substring(2, 4), 16);
        const b = parseInt(h.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };

    return (
        <div className="int-page">
            <section className="int-hero-section">
                <div className="int-hero-overlay"></div>
                <div className="int-hero-content sr-left">
                    <h1 className="int-hero-title">Intermediates</h1>
                    <p className="int-hero-paragraph">
                        Partner with us for a reliable supply of high-quality pharmaceutical intermediates that meet global standards
                    </p>
                </div>
            </section>

            <div className="int-breadcrumb-container" >
                <div className="int-breadcrumb-wrapper">
                    <Link to="/" className="int-breadcrumb-link int-home-link">
                        <HomeIcon /> Home
                    </Link>
                    <span className="int-breadcrumb-separator" style={{ padding: "10px" }}>›</span>
                    <span className="int-breadcrumb-current">Intermediates</span>
                </div>
            </div>

            <section className="int-portfolio-section">
                <div className="int-portfolio-container">
                    <div className="int-portfolio-header scroll-reveal">
                        <h2 className="int-portfolio-title">Intermediates Portfolio</h2>
                        <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                        <p className="int-portfolio-description">
                            Our intermediates portfolio supports the synthesis of multiple APIs and reflects our strong process chemistry capabilities and backward integration.
                        </p>
                    </div>

                    <div className="int-accordion-container" data-stagger="true">
                        {intermediatesData.map((product, index) => (
                            <div key={product.id} className={`int-accordion-item ${activeIndex === index ? 'active' : ''}`}>
                                <div
                                    className="int-accordion-header"
                                    onClick={() => toggleAccordion(index)}
                                    style={activeIndex === index ? {
                                        background: `linear-gradient(90deg, ${getTranslucentColor(product.color, 0.07)} 0%, #FFF 60%)`
                                    } : {}}
                                >
                                    <div className="int-accordion-header-left">
                                        <div className="int-color-bar" style={{ background: product.color }}></div>
                                        <LabIcon color={product.color} />
                                        <div className="int-product-info">
                                            <h3>{product.name}</h3>
                                            <span>
                                                <AnimatedCounter value={product.count} /> intermediates
                                            </span>
                                        </div>
                                    </div>
                                    <div className="int-accordion-header-right">
                                        <div
                                            className="int-arrow-box"
                                            style={activeIndex === index ? {
                                                background: getTranslucentColor(product.color, 0.09)
                                            } : {}}
                                        >
                                            {activeIndex === index ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M12 10L8 6L4 10" stroke={product.color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            ) : (
                                                <DownArrow />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {activeIndex === index && (
                                    <div className="int-accordion-content">
                                        <div className="int-table-header">
                                            <span className="int-col-no">NO.</span>
                                            <span className="int-col-name-heading">INTERMEDIATE NAME</span>
                                            <span className="int-col-cas">CAS NO.</span>
                                        </div>
                                        <div className="int-table-body">
                                            {product.items.map((item) => (
                                                <div key={item.no} className="int-table-row">
                                                    <span className="int-col-no">{item.no}</span>
                                                    <span className="int-col-name">{item.name}</span>
                                                    <span className="int-col-cas">
                                                        <span
                                                            className="int-cas-badge"
                                                            style={{
                                                                background: getTranslucentColor(product.color, 0.05),
                                                                border: `1px solid ${getTranslucentColor(product.color, 0.19)}`,
                                                                color: product.color,
                                                                borderRadius: '8px'
                                                            }}
                                                        >
                                                            {item.cas}
                                                        </span>
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Intermediates;